import * as React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { RespuestaReporteDetalle } from "../modelo/ReporteGlosasModelo";
import { Col, Row, Glyphicon, Tooltip as TooltipAyuda, OverlayTrigger } from "react-bootstrap";
import ReactTable from "react-table";

export default class GraficaTorta extends React.Component<GraficaTortaProps, any> {

    COLOR_OK = "#82CA9D";
    COLORES = ["#0088FE", "#972FBD", "#00C49F", "#FFBB28", "#FF8042", "#E63030", "#8884D8", "#84A6ED", "#8DD0E0", "#82C99D", "#A4DE6D", "#D0ED57"];

    columns = [{
        Header: "Glosa",
        accessor: "Glosa",
        Cell: props => (this.renderTextoGlosa(props)),
        width: 80
    }, {
        Header: "Cantidad",
        accessor: "Cantidad",
        width: 80
    }, {
        Header: "Color",
        accessor: "Color",
        Cell: props => (this.renderColorIcono(props)),
        width: 70
    }];

    renderTextoGlosa = (props: any) => {
        const textoTooltip = () => {
            return props.original.TextoGlosa ? props.original.TextoGlosa : `No se encontro la Glosa ${props.value} para este servicio.`;
        };

        const tooltip = (
            <TooltipAyuda id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{textoTooltip()}</TooltipAyuda>
        );

        return (
            <OverlayTrigger placement="top" overlay={tooltip}>
                <p style={props.original.TextoGlosa ? {} : { color: "red" }}>{props.value}</p>
            </OverlayTrigger>
        );
    }

    renderColorIcono = (props: any) => {
        return (
            <Glyphicon glyph={"tag"} style={{ color: props.value, paddingLeft: "20px" }} />
        );
    }

    definirColor = (dato: RespuestaReporteDetalle, indice: number) => {
        if (dato.Glosa === "OK") return this.COLOR_OK;
        else return this.COLORES[indice % this.COLORES.length];
    }

    renderColorSector = (datos: Array<RespuestaReporteDetalle>) => {
        datos.forEach((dato, indice) => {
            dato.Color = this.definirColor(dato, indice);
        });

        return (
            datos.map((dato, indice) => (
                <Cell key={`cell-${indice}`} fill={dato.Color} />
            ))
        );
    };

    render() {
        const { datos } = this.props;

        const tooltip = (
            <TooltipAyuda id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{"Regresar"}</TooltipAyuda>
        );

        return (
            <div className={"card"} >
                <div className={"card-header"}>
                    <h3 className={"panel-title"}>Reporte detalle Servicio {datos && datos.length ? datos[0].Servicio : ""}
                        <button type="button" className="btns-glyphicon" style={{ float: "right", marginRight: "40px" }} onClick={this.props.regresarReporteGeneral}>
                            <OverlayTrigger placement="top" overlay={tooltip}>
                                <Glyphicon glyph={"chevron-left"} style={{ width: "22px", height: "22px" }} />
                            </OverlayTrigger>
                        </button>
                    </h3>
                </div>
                <div className={"card-body"} >
                    <Row className={"form-group"}>
                        <Col sm={3}>
                            <ReactTable data={datos}
                                columns={this.columns}
                                manual
                                sortable={false}
                                resizable={false}
                                loadingText={"Cargando..."}
                                noDataText={"No se ha encontrado información."}
                                className={"-highlight -striped"}
                                pageSize={datos.length}
                                pages={0}
                                showPagination={false}
                            />
                        </Col>
                        <Col sm={9}>
                            <PieChart width={900} height={600}>
                                <Pie
                                    data={datos}
                                    cx={400}
                                    cy={300}
                                    labelLine={false}
                                    outerRadius={250}
                                    fill="#8884d8"
                                    nameKey="Glosa"
                                    dataKey="Cantidad"
                                    paddingAngle={0.5}
                                >
                                    {this.renderColorSector(datos)}
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

interface GraficaTortaProps {
    datos: Array<RespuestaReporteDetalle>,
    regresarReporteGeneral?: () => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/componentes/GraficaTorta.tsx